"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCardsPrintableGroups;
const uuid_1 = require("uuid");
const Template_1 = require("../../../models/Template");
const createCardPrintable_1 = __importDefault(require("./createCardPrintable"));
function createCardsPrintableGroups(userId, projectId, creationDate, template) {
  let currentPrintableGroups = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var _a;
  if (!(0, Template_1.isTemplate2024)(template)) {
    throw new Error('Error when creating cards printable groups: Unsupported template schema version');
  }
  const newPrintableGroups = [];
  const currentCardFrontPrintableGroup = currentPrintableGroups.find(group => group.type === 'cardFront');
  if (currentCardFrontPrintableGroup) {
    newPrintableGroups.push(currentCardFrontPrintableGroup);
  } else {
    const printableGroupId = (0, uuid_1.v5)(`Time ${creationDate} cardFront Printable Group`, projectId);
    const printableId = (0, uuid_1.v5)(`Time ${creationDate} cardFront Printable`, printableGroupId);
    const newCardFrontPrintable = (0, createCardPrintable_1.default)({
      userId,
      projectId,
      creationDate,
      template,
      printableGroupType: 'cardFront',
      printableId
    });
    newPrintableGroups.push({
      id: printableGroupId,
      qty: 1,
      printables: [newCardFrontPrintable],
      type: 'cardFront'
    });
  }
  const hasCardBack = template.designs.some(design => {
    var _a;
    return (_a = design.allowedPrintableGroupTypes) === null || _a === void 0 ? void 0 : _a.includes('cardBack');
  });
  const currentCardBackPrintableGroup = currentPrintableGroups.find(group => group.type === 'cardBack');
  if (hasCardBack && currentCardBackPrintableGroup) {
    newPrintableGroups.push(currentCardBackPrintableGroup);
  } else if (hasCardBack) {
    const printableGroupId = (0, uuid_1.v5)(`Time ${creationDate} cardBack Printable Group`, projectId);
    const printableId = (0, uuid_1.v5)(`Time ${creationDate} cardBack Printable`, printableGroupId);
    const newCardBackPrintable = (0, createCardPrintable_1.default)({
      userId,
      projectId,
      creationDate,
      template,
      printableGroupType: 'cardBack',
      printableId
    });
    newPrintableGroups.push({
      id: printableGroupId,
      qty: 1,
      printables: [newCardBackPrintable],
      type: 'cardBack'
    });
  }
  const hasEnvelope = (_a = template.surfaces) === null || _a === void 0 ? void 0 : _a.some(surface => {
    var _a;
    return (_a = surface.allowedPrintableGroupTypes) === null || _a === void 0 ? void 0 : _a.includes('cardEnvelopeFront');
  });
  const currentCardEnvelopeFrontPrintableGroup = currentPrintableGroups.find(group => group.type === 'cardEnvelopeFront');
  if (hasEnvelope && currentCardEnvelopeFrontPrintableGroup) {
    newPrintableGroups.push(currentCardEnvelopeFrontPrintableGroup);
  } else if (hasEnvelope && !currentCardEnvelopeFrontPrintableGroup) {
    const printableGroupId = (0, uuid_1.v5)(`Time ${creationDate} cardEnvelopeFront Printable Group`, projectId);
    const printableId = (0, uuid_1.v5)(`Time ${creationDate} cardEnvelopeFront Printable`, printableGroupId);
    const newCardEnvelopeFrontPrintable = (0, createCardPrintable_1.default)({
      userId,
      projectId,
      creationDate,
      template,
      printableGroupType: 'cardEnvelopeFront',
      printableId
    });
    newPrintableGroups.push({
      id: printableGroupId,
      qty: 1,
      printables: [newCardEnvelopeFrontPrintable],
      type: 'cardEnvelopeFront'
    });
  }
  return newPrintableGroups;
}